import { caseActions } from "../config/action-config";

let tempCasesList = [
    { id: 1, title: "Bachmanity LLC" },
    { id: 2, title: "Hooli" },
    { id: 3, title: "Pied Piper" },
]

const initial = { list: tempCasesList, error: false, selected: {} };

const casesReducer = (state = initial, action) => {
  const { payload, type } = action;
  switch (type) {
    case caseActions.ADD: return { list: [...state.list, ...payload], error: false };
    case caseActions.RELOAD: return { list: payload, error: false };
    case caseActions.REMOVE: return { list: [...state.list.filter(c => c.id !== payload)], error: false, selected: {} };
    case caseActions.ERROR: return { list: [], error: true }
    case caseActions.SELECT: return { ...state, selected: action.payload }
    default:
      return state;
  }
};

export default casesReducer;
